module.exports = __webpack_public_path__ + "static/media/dana_icon.9551c3a3.svg";